import type { FunctionComponent } from 'react';

import type { ISingleHistoryBet } from '../../../../../api/fetchers/history/types';
import { CurrencyConnected } from '../../../../currency/CurrencyConnected';

export interface NetCashProps {
  bet: ISingleHistoryBet;
}

export const NetCash: FunctionComponent<NetCashProps> = ({ bet }) => {
  return (
    <>
      <CurrencyConnected hideCurrency value={Number(bet.netCash)} />
      {bet.maxcap === 'true' ? '*' : null}
    </>
  );
};
